import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import modals from "webmodals/modals";
import $session from "servicestack/session";
// import moment from "moment";
import AutoQuery from "servicestack/auto-query/auto-query";

export default class PowerBiPromptController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		const {
			request = options.report,
			title
		} = options;
		console.info("options", options);
		$ctrl.request = {
			id: request.id,
			name: request.name,
			roles: request.roles
		};

		if (request.type && request.type != undefined) {
			$ctrl.request.typeValues = [{
				type: request.type,
				total: 1
			}];
		}

		$ctrl.action = request.id ? "Update" : "Create";
		$ctrl.bus = new ServiceBus();
		$ctrl.title = title || `${$ctrl.action} PowerBI Report...`;

		$ctrl.roles = [];
		$ctrl.rolesQuery = new AutoQuery({
			url: 'QueryRoles.json',
			autoLoad: true,
			take: 1000,
			onLoaded: function (args) {
				args.results.forEach(function (v) {
					$ctrl.roles.push(v.code);
				});
				//$ctrl.selectedRoles = $ctrl.report.roles.join(',');
			}
		});

	}

	$onInit() {
		const $ctrl = this;
	}

	submit() {
		const $ctrl = this;

		//console.info("$ctrl.request", $ctrl.request, $ctrl.action);
		//$ctrl.request.roles = $ctrl.selectedRoles.join(',');
		$ctrl.bus
			.send(`${$ctrl.action}PowerBiReport.json`, $ctrl.request)
			.then(function (response) {
				$ctrl.$emit("powerBiSaved", $ctrl);
				$ctrl.$emit("refresh-powerbi-report", response);
				$ctrl.$close(response.data);
			});
	}

	delete() {
		const $ctrl = this;
		$ctrl.request.type = $ctrl.request.type[0].type;
		$ctrl.$close($ctrl.request);

		//return modals
		//  .confirm("Are you sure?", "Delete Quick Report")
		//  .result.then(function() {
		//    $ctrl.bus
		//      .send("DeleteQuickReport.json", $ctrl.request)
		//      .then(function(response) {
		//        $ctrl.$emit("quickReportDeleted", $ctrl);
		//        $ctrl.$emit("refresh-quick-report", response);
		//      });
		//  });
	}

	dismiss() {
		const $ctrl = this;
		//$ctrl.$emit('listSaved', $ctrl);
		$ctrl.$dismiss();
	}
}
